import React from 'react';
import Login from '../login/';
import {auth} from '../../firebase/index.js';
import './index.css';
import AuthUserContext from '../AuthUserContext.js';

class Header extends React.Component {
  constructor(props){
    super(props);
    this.state = {loggedIn: false, displayLogin: false, currentUser: null, loaded: false};
    this.showLogin = this.showLogin.bind(this);
  }

  showLogin(){
    this.login.show();
  }

  render(){
    return(
      <div className="site-header">
        <div className="container-fluid">
          <div className="col-md-12">
            <a href="/">🎉 Neal.fun</a>
            {this.props.fullUser ?
              <span>
                <span onClick={() => {auth.signout(); window.location.reload();}} className="login">logout</span>
                <span className="header-user">
                  <span>
                    <img className="login-picture" src={this.props.fullUser.profilePic}/>
                    <span>{this.props.fullUser.name}</span>
                  </span>
                </span>
              </span>
              : <span onClick={this.showLogin} className="login">Login</span>}
          </div>
        </div>
        <Login onRef={ref => (this.login = ref)} />
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js